import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';
declare function setProgress(percentual, masc): any;

@Component({
  selector: 'app-dashboard-avaliacao',
  templateUrl: './dashboard-avaliacao.component.html',
  styleUrls: ['./dashboard-avaliacao.component.css']
})
export class DashboardAvaliacaoComponent implements OnInit {
  //@ViewChild("ccombroInput") ccombroInput: ElementRef;
  //@ViewChild("cctroncoInput") cctroncoInput: ElementRef;


  arrInpCC: any[] = ['ccombro', 'cctronco', 'ccabdom', 'ccquadril', 'ccbracodrelax', 'ccbracodcont', 'ccbracoerelax', 'ccbracoecont', 'ccantbd', 'ccantbe', 'cccoxad', 'cccoxae', 'ccpernad', 'ccpernae', 'cccintura'];
  arrInpMM: any[] = ['mmsubescapular', 'mmtricipital', 'mmpeitoral', 'mmbicipital', 'mmabdominal', 'mmaxilar', 'mmsuprailiaca', 'mmcoxa', 'mmpanturrilha'];
  arrProtocolos: any[] = ['', 'Falkner', 'Pollock 7D', 'Pollock 3D', 'Guedes', 'Petroski', 'Thorland 7D', 'Thorland 3D'];
  nome: any = '';
  email: any = '';
  emailconf: any = '';
  senha: any = '';
  nascimento: string = '';
  celular: string = '';
  newsletter: boolean = true;
  shouldHide: boolean = true;
  shouldHide1: boolean = false;
  shouldHide2: boolean = true;
  shouldHide3: boolean = true;
  nomeCliente: any = '';
  hideLoginLoad: boolean = true;
  meusDados: any = '';
  dadosRecuperar: any = '';
  tentativasFail: any = 0;
  isPassword: boolean = true;
  idCliente: any = 0;
  fcmToken: any = '';
  idPaciente: any = '';
  idAvaliacao: any = '';
  workAb: boolean = false;
  idade: any = '';
  peso: any = '';
  altura: any = '';
  pesosugerido: any = '';
  resultadoGFalkner: any = 0;
  protocolo: any = '';
  dobrasC1: boolean = false;
  dobrasC2: boolean = false;
  dobrasC3: boolean = false;
  dobrasC4: boolean = false;
  dobrasC5: boolean = false;
  dobrasC6: boolean = false;
  dobrasC7: boolean = false;
  dobrasC8: boolean = false;
  dobrasC9: boolean = false;
  masculino: boolean = false;
  ladocorporal: any = '';
  numKcal: any = 0;
  numFA: any = 0;
  numGET: any = 0;
  distanciaCP: any = 0;
  tcVM: any = null;
  tcVL: any = null;
  tcVO: any = null;
  cargaRM: any = null;
  repeticoesRM: any = null;
  exercicioRM: any = '';
  resultadoRM: any = null;
  titavaliacao: any = '';
  pesoGET: any = '';
  massaGET: any = '';
  equacaoGET: any = '';
  faGET: any = '';
  tmbGET: any = '';
  resGET: any = '';
  showGraph: boolean = false;
  txtGToggle: any = '';
  iconToggle: any = '';
  public maskNascimento = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  view: any[] = [600, 400];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = 'Composição Corporal';
  showYAxisLabel = true;
  yAxisLabel = 'Peso';
  timeline = true;
  colorScheme = {
    domain: ['#FF7F50', '#FFE978', '#87CEFA', '#2ade89',]
  };
  //pie
  showLabels = true;
  // data goes here
  public single = [];
  public multi = [];
  dadosCirc: any;
  dadosDobra: any;
  dadosComp: any;
  dadosCooper: any;
  dadosRM: any;
  dadosAV: any;
  dadosGET: any;
  mRotaAtual: any = '';
  avEnviada = false;
  cooldown: any = 0;

  constructor(public myElement: ElementRef, private renderer: Renderer2, private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.txtGToggle = 'Visualizar Gráfico';
    this.iconToggle = 'bar_chart';
    this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
    this.idAvaliacao = this.route.snapshot.paramMap.get('idavaliacao');
    this.mRotaAtual = 'dashboard/paciente/' + this.route.snapshot.paramMap.get('idpaciente') + '/avaliacao/' + this.route.snapshot.paramMap.get('idavaliacao');
    //this.idade = 29;
    //this.altura = '1.80';
    //this.dobrasCampo1 = true;
    //this.dobrasCampo2 = true;
    this.masculino = true;
    this.numKcal = 1700;
    this.numFA = 1.5;
    this.numGET = this.numKcal * this.numFA;

    setTimeout(() => {
      this.loadScript('../../assets/js/fillbody.js');
    }, 0);

    this.carregarAvaliacao();

  }
  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }
  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.type = 'text/javascript';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  toggleGrafico() {
    this.showGraph = !this.showGraph;
    if (!this.showGraph) {
      this.txtGToggle = 'Visualizar Gráfico';
      this.iconToggle = 'bar_chart';
      //this.carregarAvaliacao();
    }
    else {
      this.txtGToggle = 'Exibir Formulários';
      this.iconToggle = 'assignment';
      if (this.dadosComp != null) {
        this.renderizarGrafico();
      }

    }
  }

  carregarAvaliacao() {
    this.hideLoginLoad = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente + '&idavaliacao=' + this.idAvaliacao;
    this.tmaService.getInfoAvaliacao(dadosIn)
      .subscribe((qRes) => {
        console.log(qRes);
        this.hideLoginLoad = true;
        if (qRes['res'] == 'ok') {
          this.dadosCirc = qRes['infoCirc'];
          this.dadosComp = qRes['infoComp'];
          this.dadosDobra = qRes['infoDobras'];
          this.dadosCooper = qRes['infoCooper'];
          this.dadosRM = qRes['infoRM'];
          this.dadosAV = qRes['infoAv'];
          this.dadosGET = qRes['infoGET'];
          this.idade = qRes['idade'];
          if (this.dadosComp != null) {
            if (this.dadosComp.MassaGorduraPercentual != null) {
              this.massaGET = this.dadosComp.MassaLivreGorduraKg.toString().replace(".", ",");
              var numeroPerc = this.dadosComp.MassaGorduraPercentual / 100;
              setTimeout(() => {
                setProgress(numeroPerc, this.masculino);
              }, 1000);
            }
          }

          this.cooldown = qRes['cooldown'];
          //this.altura = this.dadosAV.EstaturaAluno.toLocaleString("en", {useGrouping: false, minimumFractionDigits: 2});
          this.titavaliacao = this.dadosAV.Titulo;
          if (this.dadosAV.Enviada) {
            this.avEnviada = true;
          }
          if (qRes['altura'] !== null) {
            //this.altura = qRes['altura'].toLocaleString("en", { useGrouping: false, minimumFractionDigits: 2 });
            this.altura = qRes['altura'];
          }

          if (this.dadosAV !== null) {
            //this.peso = this.dadosAV.PesoAluno.toLocaleString("en", { useGrouping: false, minimumFractionDigits: 2 });
            //this.peso = this.dadosAV.PesoAluno;
            this.peso = this.dadosAV.PesoAluno.toString().replace('.', ',');
            this.pesoGET = this.peso;
          }


          if (qRes['sexo'] == 'Masculino') {
            this.masculino = true;
          }
          else {
            this.masculino = false;
          }
          console.log(this.dadosCirc);
          if (this.dadosCirc != null) {
            this.renderer.selectRootElement('#' + this.arrInpCC[0]).value = this.dadosCirc.MedOmbro;
            this.renderer.selectRootElement('#' + this.arrInpCC[1]).value = this.dadosCirc.MedTronco;
            this.renderer.selectRootElement('#' + this.arrInpCC[2]).value = this.dadosCirc.MedAbdomem;
            this.renderer.selectRootElement('#' + this.arrInpCC[3]).value = this.dadosCirc.MedQuadril;
            this.renderer.selectRootElement('#' + this.arrInpCC[4]).value = this.dadosCirc.MedBracoDRelax;
            this.renderer.selectRootElement('#' + this.arrInpCC[5]).value = this.dadosCirc.MedBracoDContra;
            this.renderer.selectRootElement('#' + this.arrInpCC[6]).value = this.dadosCirc.MedBracoERelax;
            this.renderer.selectRootElement('#' + this.arrInpCC[7]).value = this.dadosCirc.MedBracoEContra;
            this.renderer.selectRootElement('#' + this.arrInpCC[8]).value = this.dadosCirc.MedAntBracoD;
            this.renderer.selectRootElement('#' + this.arrInpCC[9]).value = this.dadosCirc.MedAntBracoE;
            this.renderer.selectRootElement('#' + this.arrInpCC[10]).value = this.dadosCirc.MedCoxaD;
            this.renderer.selectRootElement('#' + this.arrInpCC[11]).value = this.dadosCirc.MedCoxaE;
            this.renderer.selectRootElement('#' + this.arrInpCC[12]).value = this.dadosCirc.MedPernaD;
            this.renderer.selectRootElement('#' + this.arrInpCC[13]).value = this.dadosCirc.MedPernaE;
          }
          //arrInpMM: any[] = ['mmsubescapular', 'mmtricipital','mmpeitoral', 'mmbicipital', 'mmabdominal', 'mmaxilar', 'mmsuprailiaca', 'mmcoxa', 'mmpanturrilha'];
          if (this.dadosDobra !== null) {
            this.renderer.selectRootElement('#' + this.arrInpMM[2]).value = this.dadosDobra.DbPeitoral;
            this.renderer.selectRootElement('#' + this.arrInpMM[5]).value = this.dadosDobra.DbAxilarMedia;
            this.renderer.selectRootElement('#' + this.arrInpMM[0]).value = this.dadosDobra.DbSubescapular;
            this.renderer.selectRootElement('#' + this.arrInpMM[1]).value = this.dadosDobra.DbTriceps;
            this.renderer.selectRootElement('#' + this.arrInpMM[3]).value = this.dadosDobra.DbBiceps;
            this.renderer.selectRootElement('#' + this.arrInpMM[6]).value = this.dadosDobra.DbSuprailiaca;
            this.renderer.selectRootElement('#' + this.arrInpMM[4]).value = this.dadosDobra.DbAdbominal;
            this.renderer.selectRootElement('#' + this.arrInpMM[7]).value = this.dadosDobra.DbCoxaMedial;
            this.renderer.selectRootElement('#' + this.arrInpMM[8]).value = this.dadosDobra.DbPerna;
          }
          if (this.dadosComp !== null) {
            console.log(this.dadosComp.Protocolo);
            if (this.dadosComp.Protocolo !== null) {
              var indexProt = this.arrProtocolos.indexOf(this.dadosComp.Protocolo.toString());
              console.log(indexProt);
              this.protocolo = indexProt;
              this.ladocorporal = this.dadosComp.Lado;
            }
            this.pesosugerido = this.dadosComp.PesoSugerido.toString().replace('.', ',');
          }

          if (this.dadosCooper !== null) {
            this.distanciaCP = this.dadosCooper.Distancia;
            this.tcVM = this.dadosCooper.VelocidadeMedia;
            this.tcVL = this.dadosCooper.VelocidadeLimiar;
            this.tcVO = this.dadosCooper.VolumeOx;
          }

          if (this.dadosRM !== null) {
            this.exercicioRM = this.dadosRM.Exercicio;
            this.cargaRM = this.dadosRM.PesoLevantado;
            this.repeticoesRM = this.dadosRM.NumeroRepeticoes.toString();
            this.resultadoRM = this.dadosRM.ResultadoRM;
          }

          if (this.dadosGET !== null) {
            this.equacaoGET = this.dadosGET.Equacao;
            this.faGET = this.dadosGET.FA.toString();
            this.tmbGET = this.dadosGET.TMB;
            this.resGET = this.dadosGET.ResultadoGET;
          }

        }
      })
  }

  tabCg(qTab: any): void {
    console.log(qTab);
    if (qTab.index == 3) {
      if (this.dadosComp != null) {
        setTimeout(() => {
          var numeroPerc = this.dadosComp.MassaGorduraPercentual / 100;
          setProgress(numeroPerc, this.masculino);
          //setProgress(0.25, this.masculino);
        }, 1000);
      }

      this.renderizarGrafico();

    }
    else {

    }
  }

  renderizarGrafico(): void {

    this.single = [{
      "name": "Peso Total ",
      "value": this.peso.replace(',', '.')
    },
    {
      "name": "Massa de Gordura",
      "value": this.dadosComp.MassaGorduraKg
    },
    {
      "name": "Massa Magra",
      "value": this.dadosComp.MassaLivreGorduraKg
    },
    ];

    // {
    //   "name": "Peso Ideal",
    //   "value": 86
    // },

    this.multi = [
      {
        "name": "Peso Total",
        "series": [
          {
            "name": "Janeiro",
            "value": 92
          },
          {
            "name": "Fevereiro",
            "value": 98
          },
          {
            "name": "Março",
            "value": 95
          }
        ]
      },
      {
        "name": "Massa de Gordura",
        "series": [
          {
            "name": "Janeiro",
            "value": 12
          },
          {
            "name": "Fevereiro",
            "value": 8
          },
          {
            "name": "Março",
            "value": 15
          }
        ]
      }
    ];


  }

  digitouPeso(): void {
    this.pesoGET = this.peso;
  }

  digitouPeso2(): void {
    this.peso = this.pesoGET;
  }
  digitou(info: string): void {
    console.log(info);
    this.email = info;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email);
    console.log("R " + re);

  }
  digitouEc(info: string): void {

  }
  togglePW(): void {
    this.isPassword = !this.isPassword;
    console.log(this.isPassword);
  }

  calcularCooper(): void {

    if (this.cooldown > 3 && this.avEnviada) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Esta avaliação já foi enviada há mais de 3 dias e não é possível editar ou realizar mais cálculos.<br>Caso necessário crie uma nova avaliação para este paciente.", iconAlerta: 'warning' }
      });
    }
    else {
      //serverside
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idpaciente: this.idPaciente,
        idavaliacao: this.idAvaliacao,
        distancia: this.distanciaCP.replace('.', '').replace(',', '')
      };

      this.hideLoginLoad = false;
      this.tmaService.salvarTesteCooper(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        if (qRes['res'] == 'ok') {
          this.tcVM = parseFloat(((this.distanciaCP.replace(',', '.') / (12 * 60)) * 3.6).toString()).toFixed(1);
          this.tcVL = parseFloat((2.73825 + 0.6945 * this.tcVM).toString()).toFixed(1);
          this.tcVO = parseFloat(((this.distanciaCP.replace(',', '.') - 504.1) / 44.9).toString()).toFixed(1);
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro realizar os cálculos deste teste. Tente novamente", iconAlerta: 'warning' }
          })
        }
      });
    }
  }

  calcularRM(): void {
    if (this.cooldown > 3 && this.avEnviada) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Esta avaliação já foi enviada há mais de 3 dias e não é possível editar ou realizar mais cálculos.<br>Caso necessário crie uma nova avaliação para este paciente.", iconAlerta: 'warning' }
      });
    }
    else {
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idpaciente: this.idPaciente,
        idavaliacao: this.idAvaliacao,
        carga: this.cargaRM.replace('.', ','),
        repeticoes: this.repeticoesRM,
        exercicio: this.exercicioRM
      };

      this.hideLoginLoad = false;
      this.tmaService.salvarTesteRM(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        if (qRes['res'] == 'ok') {
          //this.resultadoRM = parseFloat((this.cargaRM.replace(',','.') / (1.0278 - 0.0278 * this.repeticoesRM)).toString()).toFixed(0);
          this.resultadoRM = qRes['cargaMax'];
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro realizar os cálculos deste teste. Tente novamente", iconAlerta: 'warning' }
          })
        }
      });
    }


  }

  calcularGET(): void {
    if (this.cooldown > 3 && this.avEnviada) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Esta avaliação já foi enviada há mais de 3 dias e não é possível editar ou realizar mais cálculos.<br>Caso necessário crie uma nova avaliação para este paciente.", iconAlerta: 'warning' }
      });
    }
    else {
      if (this.equacaoGET == '') {
        const selecEqua = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve selecionar uma das <b>equações</b> para calcular o GET", iconAlerta: 'warning' }
        })
        return;
      }
      if (this.pesoGET == '') {
        const seleFA = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve informar o <b>peso total em kg<b> para calcular o GET", iconAlerta: 'warning' }
        })
        return;
      }
      if (this.massaGET == '') {
        const seleFA = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve informar a <b>massa magra em kg<b> para calcular o GET", iconAlerta: 'warning' }
        })
        return;
      }

      if (this.faGET == '') {
        const seleFA = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve informar o <b>fator de atividade</b> para calcular o GET", iconAlerta: 'warning' }
        })
        return;
      }

      //serverside
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idpaciente: this.idPaciente,
        idavaliacao: this.idAvaliacao,
        protocolo: this.equacaoGET,
        //peso: this.peso.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        peso: this.pesoGET.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        altura: this.altura.toString().replace('.', '').replace(',', ''),
        fatoratividade: this.faGET.replace('.', ','),
        //fatoratividade: this.faGET,
        //pesoMassa: this.massaGET.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', '')
        pesoMassa: this.massaGET.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', '')
      };

      this.hideLoginLoad = false;
      this.tmaService.salvarTesteGET(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        if (qRes['res'] == 'ok') {
          this.tmbGET = qRes['taxamb'];
          this.resGET = qRes['gasto'].toFixed(2);
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro realizar os cálculos do GET. Tente novamente", iconAlerta: 'warning' }
          })
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const avisoErro = this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", textoConfirm: "OK", iconAlerta: 'warning' }
          });
          avisoErro.afterClosed().subscribe((result) => {

          });
        });
    }

  }



  calcularDobras(): void {
    if (this.cooldown > 3 && this.avEnviada) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Esta avaliação já foi enviada há mais de 3 dias e não é possível editar ou realizar mais cálculos.<br>Caso necessário crie uma nova avaliação para este paciente.", iconAlerta: 'warning' }
      });
    }
    else {
      var xDobras = {};
      xDobras = {
        DbTriceps: (this.renderer.selectRootElement('#' + this.arrInpMM[1]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[1]).value.replace(",", "."),
        DbSubescapular: (this.renderer.selectRootElement('#' + this.arrInpMM[0]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[0]).value.replace(",", "."),
        DbPeitoral: (this.renderer.selectRootElement('#' + this.arrInpMM[2]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[2]).value.replace(",", "."),
        DbBiceps: (this.renderer.selectRootElement('#' + this.arrInpMM[3]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[3]).value.replace(",", "."),
        DbAdbominal: (this.renderer.selectRootElement('#' + this.arrInpMM[4]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[4]).value.replace(",", "."),
        DbAxilarMedia: (this.renderer.selectRootElement('#' + this.arrInpMM[5]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[5]).value.replace(",", "."),
        DbSuprailiaca: (this.renderer.selectRootElement('#' + this.arrInpMM[6]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[6]).value.replace(",", "."),
        DbCoxaMedial: (this.renderer.selectRootElement('#' + this.arrInpMM[7]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[7]).value.replace(",", "."),
        DbPerna: (this.renderer.selectRootElement('#' + this.arrInpMM[8]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[8]).value.replace(",", ".")
      };

      var arrayDb = JSON.stringify(xDobras);
      console.log(this.peso);

      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idpaciente: this.idPaciente,
        idavaliacao: this.idAvaliacao,
        dadosDobras: arrayDb,
        metodoCalc: (this.arrProtocolos[this.protocolo] == null) ? '' : this.arrProtocolos[this.protocolo],
        pesoatual: this.peso.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        pesosugerido: (this.pesosugerido == '') ? 0 : this.pesosugerido.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        //altura: this.altura.toString().replace('.', '').replace(',',''),
        ladoc: this.ladocorporal
      };


      this.hideLoginLoad = false;
      this.tmaService.salvarDobras(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'ok') {
          //this.carregarAvaliacao();
          this.dadosComp = qRes['avComposicao'];

        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }


  }


  onKeydownEvent(event: KeyboardEvent, nPosicao: any): void {
    if (event.keyCode === 13 && event.shiftKey) {
      // On 'Shift+Enter' do this...
      console.log("foii");
    }
    if (event.keyCode === 13) {
      this.keytab(nPosicao);
    }
    // if(event.ctrlKey){
    //   this.keyback(nPosicao);
    // }
    if (event.keyCode == 38) {
      this.keyback(nPosicao);
    }
    if (event.keyCode == 40) {
      this.keytab(nPosicao);
    }
  }

  keyback(qPosicao: any): void {
    console.log(qPosicao);
    console.log(this.arrInpCC.length);

    if (qPosicao < this.arrInpCC.length && qPosicao !== 0) {
      setTimeout(() => {
        this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao - 1]).focus();
        // if(this.renderer.selectRootElement('#'  + this.arrInpCC[qPosicao]).value == ''){
        //   this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao - 1]).focus();
        //   // if(this.workAb){
        //   //   this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao - 1]).focus();
        //   //   console.log(this.renderer.selectRootElement('#'  + this.arrInpCC[qPosicao]).value);
        //   //   this.workAb = false;
        //   // }
        //   // else{
        //   //   this.workAb = true;
        //   // }
        // }
        // else{
        //   this.workAb = false;
        // }
      }, 0);
    }
    else {
      this.renderer.selectRootElement('#' + this.arrInpCC[0]).focus();
    }
  }
  keytab(qPosicao: any): void {
    console.log(qPosicao);
    console.log(this.arrInpCC.length);
    this.workAb = false;
    if (qPosicao !== this.arrInpCC.length - 1) {
      setTimeout(() => {
        this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao + 1]).focus();
        console.log(this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao]).value);
        var tempValue = this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao + 1]).value;
        this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao + 1]).value = ''
        this.renderer.selectRootElement('#' + this.arrInpCC[qPosicao + 1]).value = tempValue

      }, 0);
    }
    else {

    }


    // switch(qPosicao) { 
    //   case 0 : {
    //     //this.myElement.nativeElement.select('#cctroncoInput').focus();
    //     setTimeout(() => {
    //       this.renderer.selectRootElement('#cctronco').focus();
    //       console.log(this.renderer.selectRootElement('#cctronco').value);
    //     }, 0);
    //     //this.cctroncoInput.nativeElement.focus();  
    //   }

    // }
    // if(qPosicao == 0){
    //   this.cctroncoInput.nativeElement.focus();
    //   console.log(this.cctroncoInput.nativeElement.value);
    // }

  }

  pickLado(qEvent: any): void {
    console.log(qEvent);
    this.ladocorporal = qEvent.value;
  }
  camposProtocolo(qEvent: any): void {
    console.log(qEvent);
    if (this.protocolo == 1) {
      this.dobrasC1 = false;
      this.dobrasC2 = false;
      this.dobrasC3 = true;
      this.dobrasC4 = true;
      this.dobrasC5 = true;
      this.dobrasC6 = false;
      this.dobrasC7 = true;
      this.dobrasC8 = false;
      this.dobrasC9 = false;
    }
    if (this.protocolo == 2) {
      this.dobrasC1 = true;
      this.dobrasC2 = true;
      this.dobrasC3 = true;
      this.dobrasC4 = true;
      this.dobrasC5 = false;
      this.dobrasC6 = true;
      this.dobrasC7 = true;
      this.dobrasC8 = true;
      this.dobrasC9 = false;
    }
    if (this.protocolo == 3) {
      this.dobrasC1 = true;
      this.dobrasC2 = false;
      this.dobrasC3 = false;
      this.dobrasC4 = false;
      this.dobrasC5 = false;
      this.dobrasC6 = false;
      this.dobrasC7 = true;
      this.dobrasC8 = true;
      this.dobrasC9 = false;
    }
    if (this.protocolo == 4) {
      this.dobrasC1 = false;
      this.dobrasC2 = false;
      this.dobrasC3 = false;
      this.dobrasC4 = true;
      this.dobrasC5 = false;
      this.dobrasC6 = true;
      this.dobrasC7 = true;
      this.dobrasC8 = false;
      this.dobrasC9 = false;
    }
    if (this.protocolo == 5) {
      this.dobrasC1 = false;
      this.dobrasC2 = false;
      this.dobrasC3 = true;
      this.dobrasC4 = true;
      this.dobrasC5 = false;
      this.dobrasC6 = true;
      this.dobrasC7 = false;
      this.dobrasC8 = false;
      this.dobrasC9 = true;
    }
    if (this.protocolo == 6) {
      this.dobrasC1 = false;
      this.dobrasC2 = true;
      this.dobrasC3 = true;
      this.dobrasC4 = true;
      this.dobrasC5 = false;
      this.dobrasC6 = true;
      this.dobrasC7 = true;
      this.dobrasC8 = true;
      this.dobrasC9 = true;
    }
    if (this.protocolo == 7) {
      this.dobrasC1 = false;
      this.dobrasC2 = true;
      this.dobrasC3 = true;
      this.dobrasC4 = true;
      this.dobrasC5 = false;
      this.dobrasC6 = false;
      this.dobrasC7 = false;
      this.dobrasC8 = false;
      this.dobrasC9 = false;
    }
  }


  salvarAvl(): void {
    if (this.cooldown > 3 && this.avEnviada) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Esta avaliação já foi enviada há mais de 3 dias e não é possível editar ou realizar mais cálculos.<br>Caso necessário crie uma nova avaliação para este paciente.", iconAlerta: 'warning' }
      });
    }
    else {
      // console.log(this.altura.splice(1, ","));
      var testeAltura = this.altura.toString();
      if (testeAltura.length == 3) {
        testeAltura = testeAltura.slice(0, 1) + "," + testeAltura.slice(1, testeAltura.length);
        console.log(testeAltura);
      }
      else {
        //altura menor, inserir o zero antes
        testeAltura = "0," + testeAltura;
        console.log(testeAltura);
      }

      var xDobras = {};
      var xCirc = {};

      xDobras = {
        DbTriceps: (this.renderer.selectRootElement('#' + this.arrInpMM[1]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[1]).value.replace(",", "."),
        DbSubescapular: (this.renderer.selectRootElement('#' + this.arrInpMM[0]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[0]).value.replace(",", "."),
        DbPeitoral: (this.renderer.selectRootElement('#' + this.arrInpMM[2]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[2]).value.replace(",", "."),
        DbBiceps: (this.renderer.selectRootElement('#' + this.arrInpMM[3]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[3]).value.replace(",", "."),
        DbAdbominal: (this.renderer.selectRootElement('#' + this.arrInpMM[4]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[4]).value.replace(",", "."),
        DbAxilarMedia: (this.renderer.selectRootElement('#' + this.arrInpMM[5]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[5]).value.replace(",", "."),
        DbSuprailiaca: (this.renderer.selectRootElement('#' + this.arrInpMM[6]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[6]).value.replace(",", "."),
        DbCoxaMedial: (this.renderer.selectRootElement('#' + this.arrInpMM[7]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[7]).value.replace(",", "."),
        DbPerna: (this.renderer.selectRootElement('#' + this.arrInpMM[8]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[8]).value.replace(",", ".")
      };

      //arrInpCC: any[] = ['ccombro', 'cctronco', 'ccabdom', 'ccquadril', 'ccbracodrelax', 'ccbracodcont', 'ccbracoerelax', 'ccbracoecont', 'ccantbd', 'ccantbe', 'cccoxad', 'cccoxae', 'ccpernad', 'ccpernae' ];
      xCirc = {
        MedOmbro: (this.renderer.selectRootElement('#' + this.arrInpCC[0]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[0]).value.replace(",", "."),
        MedTronco: (this.renderer.selectRootElement('#' + this.arrInpCC[1]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[1]).value.replace(",", "."),
        MedAbdomem: (this.renderer.selectRootElement('#' + this.arrInpCC[2]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[2]).value.replace(",", "."),
        MedQuadril: (this.renderer.selectRootElement('#' + this.arrInpCC[3]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[3]).value.replace(",", "."),
        MedBracoDRelax: (this.renderer.selectRootElement('#' + this.arrInpCC[4]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[4]).value.replace(",", "."),
        MedBracoDContra: (this.renderer.selectRootElement('#' + this.arrInpCC[5]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[5]).value.replace(",", "."),
        MedBracoERelax: (this.renderer.selectRootElement('#' + this.arrInpCC[6]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[6]).value.replace(",", "."),
        MedBracoEContra: (this.renderer.selectRootElement('#' + this.arrInpCC[7]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[7]).value.replace(",", "."),
        MedAntBracoD: (this.renderer.selectRootElement('#' + this.arrInpCC[8]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[8]).value.replace(",", "."),
        MedAntBracoE: (this.renderer.selectRootElement('#' + this.arrInpCC[9]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[9]).value.replace(",", "."),
        MedCoxaD: (this.renderer.selectRootElement('#' + this.arrInpCC[10]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[10]).value.replace(",", "."),
        MedCoxaE: (this.renderer.selectRootElement('#' + this.arrInpCC[11]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[11]).value.replace(",", "."),
        MedPernaD: (this.renderer.selectRootElement('#' + this.arrInpCC[12]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[12]).value.replace(",", "."),
        MedPernaE: (this.renderer.selectRootElement('#' + this.arrInpCC[13]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[13]).value.replace(",", "."),
        MedCintura: (this.renderer.selectRootElement('#' + this.arrInpCC[14]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[14]).value.replace(",", "."),
        somaMedidas: 0
      };

      var arrayDb = JSON.stringify(xDobras);
      var arrayCc = JSON.stringify(xCirc);
      console.log(this.peso);



      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idpaciente: this.idPaciente,
        idavaliacao: this.idAvaliacao,
        dadosDobras: arrayDb,
        dadosCirc: arrayCc,
        metodoCalc: (this.arrProtocolos[this.protocolo] == null) ? '' : this.arrProtocolos[this.protocolo],
        pesoatual: this.peso.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        pesosugerido: (this.pesosugerido == '') ? 0 : this.pesosugerido.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        //altura: this.altura.replace('.', ','),
        altura: testeAltura,
        titavaliacao: this.titavaliacao,
        ladoc: this.ladocorporal,
        enviar: false
      };

      this.hideLoginLoad = false;
      this.tmaService.salvarAvaliacao(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'ok') {
          this.carregarAvaliacao();
        }
      })
    }

  }


  enviarAvl(): void {
    if (this.cooldown > 3 && this.avEnviada) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Esta avaliação já foi enviada há mais de 3 dias e não é possível editar ou realizar mais cálculos.<br>Caso necessário crie uma nova avaliação para este paciente.", iconAlerta: 'warning' }
      });
    }
    else {
      const sendAval = this.dialog.open(AlertaConfirmDialog, {
        //width: '250px',
        disableClose: true,
        data: { iconAlerta: "send", tituloAlerta: "Enviar", textoAlerta: "Após enviar esta avaliação, não será possível editá-la. Confirma o envio?", textoCancel: 'Não', textoConfirm: "SIM" }
      });

      sendAval.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          //server side
          this.hideLoginLoad = false;
          var xDobras = {};
          var xCirc = {};

          var testeAltura = this.altura.toString();
          if (testeAltura.length == 3) {
            testeAltura = testeAltura.slice(0, 1) + "," + testeAltura.slice(1, testeAltura.length);
            console.log(testeAltura);
          }
          else {
            //altura menor, inserir o zero antes
            testeAltura = "0," + testeAltura;
            console.log(testeAltura);
          }


          xDobras = {
            DbTriceps: (this.renderer.selectRootElement('#' + this.arrInpMM[1]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[1]).value.replace(",", "."),
            DbSubescapular: (this.renderer.selectRootElement('#' + this.arrInpMM[0]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[0]).value.replace(",", "."),
            DbPeitoral: (this.renderer.selectRootElement('#' + this.arrInpMM[2]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[2]).value.replace(",", "."),
            DbBiceps: (this.renderer.selectRootElement('#' + this.arrInpMM[3]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[3]).value.replace(",", "."),
            DbAdbominal: (this.renderer.selectRootElement('#' + this.arrInpMM[4]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[4]).value.replace(",", "."),
            DbAxilarMedia: (this.renderer.selectRootElement('#' + this.arrInpMM[5]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[5]).value.replace(",", "."),
            DbSuprailiaca: (this.renderer.selectRootElement('#' + this.arrInpMM[6]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[6]).value.replace(",", "."),
            DbCoxaMedial: (this.renderer.selectRootElement('#' + this.arrInpMM[7]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[7]).value.replace(",", "."),
            DbPerna: (this.renderer.selectRootElement('#' + this.arrInpMM[8]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpMM[8]).value.replace(",", ".")
          };

          //arrInpCC: any[] = ['ccombro', 'cctronco', 'ccabdom', 'ccquadril', 'ccbracodrelax', 'ccbracodcont', 'ccbracoerelax', 'ccbracoecont', 'ccantbd', 'ccantbe', 'cccoxad', 'cccoxae', 'ccpernad', 'ccpernae' ];
          xCirc = {
            MedOmbro: (this.renderer.selectRootElement('#' + this.arrInpCC[0]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[0]).value.replace(",", "."),
            MedTronco: (this.renderer.selectRootElement('#' + this.arrInpCC[1]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[1]).value.replace(",", "."),
            MedAbdomem: (this.renderer.selectRootElement('#' + this.arrInpCC[2]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[2]).value.replace(",", "."),
            MedQuadril: (this.renderer.selectRootElement('#' + this.arrInpCC[3]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[3]).value.replace(",", "."),
            MedBracoDRelax: (this.renderer.selectRootElement('#' + this.arrInpCC[4]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[4]).value.replace(",", "."),
            MedBracoDContra: (this.renderer.selectRootElement('#' + this.arrInpCC[5]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[5]).value.replace(",", "."),
            MedBracoERelax: (this.renderer.selectRootElement('#' + this.arrInpCC[6]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[6]).value.replace(",", "."),
            MedBracoEContra: (this.renderer.selectRootElement('#' + this.arrInpCC[7]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[7]).value.replace(",", "."),
            MedAntBracoD: (this.renderer.selectRootElement('#' + this.arrInpCC[8]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[8]).value.replace(",", "."),
            MedAntBracoE: (this.renderer.selectRootElement('#' + this.arrInpCC[9]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[9]).value.replace(",", "."),
            MedCoxaD: (this.renderer.selectRootElement('#' + this.arrInpCC[10]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[10]).value.replace(",", "."),
            MedCoxaE: (this.renderer.selectRootElement('#' + this.arrInpCC[11]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[11]).value.replace(",", "."),
            MedPernaD: (this.renderer.selectRootElement('#' + this.arrInpCC[12]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[12]).value.replace(",", "."),
            MedPernaE: (this.renderer.selectRootElement('#' + this.arrInpCC[13]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[13]).value.replace(",", "."),
            MedCintura: (this.renderer.selectRootElement('#' + this.arrInpCC[14]).value === '') ? 0 : this.renderer.selectRootElement('#' + this.arrInpCC[14]).value.replace(",", "."),
            somaMedidas: 0
          };

          var arrayDb = JSON.stringify(xDobras);
          var arrayCc = JSON.stringify(xCirc);
          console.log(this.peso);

          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idavaliacao: this.idAvaliacao,
            dadosDobras: arrayDb,
            dadosCirc: arrayCc,
            metodoCalc: (this.arrProtocolos[this.protocolo] == null) ? '' : this.arrProtocolos[this.protocolo],
            pesoatual: this.peso.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
            pesosugerido: (this.pesosugerido == '') ? 0 : this.pesosugerido.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
            //altura: this.altura.replace('.', ','),
            altura: testeAltura,
            titavaliacao: this.titavaliacao,
            ladoc: this.ladocorporal,
            enviar: true
          };
          this.tmaService.salvarAvaliacao(customParams)
            .subscribe((qRes) => {
              this.hideLoginLoad = true;
              if (qRes['res'] == 'ok') {
                //this.voltar();
                const sendSuccess = this.dialog.open(AlertaConfirmDialog, {
                  //width: '250px',
                  disableClose: true,
                  data: { iconAlerta: "done_outline", tituloAlerta: "Enviada", textoAlerta: "A avaliação foi disponibilizada com sucesso para o paciente!", textoConfirm: "OK" }
                });

                sendSuccess.afterClosed().subscribe(result => {
                  this.voltar();
                });
              }
              else {
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                  disableClose: true,
                  data: { textoAlerta: "Ocorreu um erro ao excluir esta avaliação. Tente novamente", iconAlerta: 'warning' }
                });
              }
            },
              (error) => {
                this.hideLoginLoad = true;
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                  disableClose: true,
                  data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                });
              })
        }
      })
    }


  }


  // salvar(): void {
  //   //calcular % gordura
  //   var qConta = 0;
  //   var fsubescap = this.renderer.selectRootElement('#' + this.arrInpMM[0]).value;
  //   var ftricipital = this.renderer.selectRootElement('#' + this.arrInpMM[1]).value;
  //   var fbicipital = this.renderer.selectRootElement('#' + this.arrInpMM[2]).value;
  //   var fabdominal = this.renderer.selectRootElement('#' + this.arrInpMM[3]).value;
  //   var somaMedidas = 0;
  //   somaMedidas = parseInt(fsubescap) + parseInt(ftricipital) + parseInt(fbicipital) + parseInt(fabdominal);
  //   this.renderer.addClass(this.renderer.selectRootElement('#' + this.arrInpMM[3]), 'highligthfield');
  //   console.log(somaMedidas);
  //   var qSub = 0.153 * somaMedidas;
  //   console.log(qSub);
  //   qConta = 5.783 + (0.153 * somaMedidas);
  //   console.log(qConta);
  // }

  voltar(): void {
    if (this.tmaService.gUrlAnterior == '') {
      this.router.navigate(['/dashboard/paciente/' + this.idPaciente]);
    }
    else {
      this.router.navigate([this.tmaService.gUrlAnterior]);
    }
  }


  jaEnviada(): void {
    const erroCriar = this.dialog.open(AlertaSimplesDialog, {
      disableClose: true,
      width: '300px',
      data: { textoAlerta: "Esta Avaliação já foi enviada anteriormente.<br>Caso necessite, volte para a tela anterior e crie uma nova avaliação.", iconAlerta: 'done_outline' }
    });
  }

  excluirAV(): void {
    const excluirAval = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: { iconAlerta: "delete_forever", tituloAlerta: "Excluir", textoAlerta: "Confirma a exclusão desta avaliação?", textoCancel: 'Não', textoConfirm: "SIM" }
    });

    excluirAval.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        //server side
        this.hideLoginLoad = false;
        let customParamsDel = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idavaliacao: this.idAvaliacao,
        };
        this.tmaService.excluirAvaliacao(customParamsDel)
          .subscribe((qRes) => {
            this.hideLoginLoad = true;
            if (qRes['res'] == 'ok') {
              this.voltar();
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro ao excluir esta avaliação. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
      }
    })
  }

}
